import { FieldComponent } from "./chunk-3JUJVI6N.js";
import { ListboxComponent } from "./chunk-ZCP2KSHO.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/ListboxField/ListboxField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var ListboxField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      required,
      requiredLabel,
      description,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "required", "requiredLabel", "description", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(FieldComponent, {
    id,
    name,
    label,
    required,
    requiredLabel,
    description,
    validation,
    validationMessage,
    className: clsx("pd:listbox-field", className),
    children: [/* @__PURE__ */jsx(FieldComponent.Label, {
      className: "pd:listbox-field__label"
    }), /* @__PURE__ */jsx(FieldComponent.Input, __spreadValues({
      ref,
      as: ListboxComponent,
      className: "pd:listbox-field__input"
    }, rest)), /* @__PURE__ */jsx(FieldComponent.ValidationMessage, {
      className: "pd:listbox-field__validation-message"
    }), /* @__PURE__ */jsx(FieldComponent.Description, {
      className: "pd:listbox-field__description"
    })]
  });
});
var ListboxField_default = ListboxField;
export { ListboxField_default };